import React from 'react';
import {
  RequestFormVisibility,
  useRequestFormsForManagerQuery,
} from '../../../__generated__/graphql';
import { RequestForm } from '../RequestForm';
import { RequestFormProps } from '../RequestForm/types';

export const ManagerRequestForm: React.FC<RequestFormProps> = (props) => {
  const { data, loading } = useRequestFormsForManagerQuery({
    skip: !props.show,
  });

  const requestFormsVisibleForManager =
    data?.requestForms.filter(
      (form) =>
        form.flair__Visibility__c === RequestFormVisibility.HrManagerEmployee ||
        form.flair__Visibility__c === RequestFormVisibility.HrManager,
    ) ?? [];

  return (
    <RequestForm
      {...props}
      requestForms={requestFormsVisibleForManager}
      employees={data?.manager?.employees ?? []}
      isSelectEmployeeStepVisible={true}
      loading={loading}
    />
  );
};
